/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import TeaserCard from "../Cards/TeaserCard/TeaserCard";
import React from "react";
import _map from "lodash/map";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material";
import { IconWrapperProps } from "../IconWrapper/IconWrapper";
import { CarouselSlides } from "../Carousel/CarouselSlides";
import { CarouselSlide } from "../Carousel/CarouselSlide";
import { useTheme } from "@mui/material/styles";
import { CarouselDots } from "../Carousel/CarouselDots";
import linkedCardBoxStyle from "./LinkedCardBoxStyle";
import { CarouselProvider } from "../Carousel/CarouselProvider";

type LinkedCardBoxProps = {
  linkedCards: Array<{
    icon: IconWrapperProps["icon"];
    heading: string;
    subHeading?: string;
    link?: string;
    linkType?: string;
    hideMobileButton?: boolean;
  }>;
  mobileCtaText?: string;
  carouselLabel?: string;
};

const LinkedCardBox = ({ linkedCards, mobileCtaText = "JETZT STARTEN", carouselLabel }: LinkedCardBoxProps) => {
  const getAllItemsDisplayedBreakpoint = () => {
    switch (linkedCards.length) {
      case 2:
        return "sm";
      case 3:
        return "md";
      case 4:
      default:
        return "lg";
    }
  };

  const allItemsDisplayed = linkedCards.length <= 4 ? useMediaQuery((theme: Theme) => theme.breakpoints.up(getAllItemsDisplayedBreakpoint())) : false;

  //current responsive object only works if the area width is above 1100 otherwise cards overlap on smaller devices
  return (
    <>
      <CarouselProvider label={carouselLabel} watchDrag={true}>
        <CarouselSlides>
          {_map(linkedCards, (card, idx) => {
            return (
              <CarouselSlide key={idx} sx={(theme) => linkedCardBoxStyle.slide(theme, linkedCards.length)}>
                <TeaserCard
                  icon={card.icon}
                  heading={card.heading}
                  subHeading={card.subHeading}
                  linkTo={card.link}
                  mobileCtaText={mobileCtaText}
                  linkType={card.linkType}
                  displayMobileCta={!card.hideMobileButton}
                />
              </CarouselSlide>
            );
          })}
        </CarouselSlides>
        {!allItemsDisplayed && <CarouselDots />}
      </CarouselProvider>
    </>
  );
};

export default LinkedCardBox;
